import React, { useEffect, useState, useMemo } from 'react';
import { Menu, MenuItem, Icon } from '@mui/material';
import Select from 'react-select';
import Swal from 'sweetalert2';

import MDBox from 'components/MDBox';
import MDInput from 'components/MDInput';
import MDModal from 'components/MDModal';
import MDButton from 'components/MDButton';
import MDTypography from 'components/MDTypography';

import { useParams } from 'react-router-dom';
import { useAppServices } from 'hook/services';
import ssoHandler from 'layouts/Pages/ssoHandler';

function AddProduct({ open, onClose, data, handleChange, type, editData, DataIndex }) {
  const Service = useAppServices();
  const [processing, setProcessing] = useState(false);
  const [linkType, setLinkType] = useState(null);
  const [page, setPage] = useState([]);
  const [link, setLink] = useState('');
  const [templateLink, setTemplateLink] = useState('');
  const [linkName, setLinkName] = useState('');
  const [selectedParams, setSelectedParams] = useState([]);
  const [errors, setErrors] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const { app_type, app_id } = useParams();
  const { SSO, checkSSO } = ssoHandler();
  const [ssodata, setssodata] = useState({});

  const AppsData = async () => {
    const { response } = await Service.snapshot_onboarding.filter({
      query: `app_id=${app_id}`,
    });
    if (response) checkSSO(response.data);
  };

  useEffect(() => {
    AppsData();
  }, []);
  useEffect(() => {
    if (SSO != '' && SSO != undefined) {
      var data = JSON.parse(SSO)
      setssodata(data)
    }
    console.log(SSO, 'SSOLINKS')
  }, [SSO]);

  const LinkTypes = useMemo(() => [
    { label: 'Knowledge Base', value: 'Knowledge Base' },
    { label: 'Road Map', value: 'Road Map' },
    { label: 'Change Logs', value: 'Change Logs' },
    { label: 'Form Link', value: 'Form Link' },
    { label: 'News Feeds', value: 'News Feeds' },
    { label: 'Submit Ticket', value: 'Submit Ticket' },
    { enable: app_type !== 'snapshot', label: 'Media Library', value: 'Media Library' },
    { enable: app_type !== 'snapshot', label: 'Onboard List', value: 'Onboard List' },
    { enable: app_type !== 'snapshot', label: 'Checklist', value: 'Checklist' },
    { enable: app_type !== 'snapshot', label: 'Quiz', value: 'Quiz' },
    { enable: app_type !== 'snapshot', label: 'Service Store', value: 'Service Store' },
  ], [app_type]);

  const Types = [
    { label: 'Pre Defined', value: 'Pre Defined' },
    { label: 'Custom', value: 'Custom' },
  ];

  const parameterOptions = useMemo(() => {
    const common = [
      { label: 'User ID', value: '{{user.Id}}' },
      { label: 'Company ID', value: '{{company.Id}}' },
      { label: 'Plan ID', value: '{{plan.Id}}' },
      { label: 'Email', value: '{{email}}' },
    ];
    if (type !== 'agency') {
      return [...common,
      { label: 'Location ID', value: '{{location.Id}}' },



      ];
    }
    return common;
  }, [type]);

  const filteredLinkTypes = useMemo(() =>
    LinkTypes.filter(item => typeof item.enable === 'undefined' || item.enable),
    [LinkTypes]
  );

  const selectedPages = useMemo(() => new Set(
    data?.[type === 'agency' ? 'agency_pages' : 'location_pages']
      ?.filter((_, idx) => !editData || idx !== DataIndex)
      ?.map(p => p.page)
  ), [data, type, editData, DataIndex]);

  const availableOptions = useMemo(() =>
    filteredLinkTypes.filter(opt => !selectedPages.has(opt.value)),
    [filteredLinkTypes, selectedPages]
  );

  useEffect(() => {
    if (editData) {
      setLinkType(editData.linkType);
      if (editData.linkType === 'Pre Defined') {
        const selectedOption = filteredLinkTypes.find(opt => opt.value === editData.page);
        setPage(selectedOption ? [selectedOption] : []);
      } else {
        const originalLink = editData.templateLink || editData.link || '';
        setLink(originalLink);
        setTemplateLink(originalLink);
        setLinkName(editData.page || '');
        const matchedParams = parameterOptions.filter(p => originalLink.includes(p.value));
        setSelectedParams(matchedParams);
      }
    } else {
      setLinkType(null);
      setPage([]);
      setLink('');
      setTemplateLink('');
      setLinkName('');
      setSelectedParams([]);
    }
    setErrors({});
  }, [editData, open, filteredLinkTypes]);

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;
    if (!linkType) {
      newErrors.linkType = 'Type is required';
      isValid = false;
    }
    if (linkType === 'Pre Defined' && (!page || page.length === 0)) {
      newErrors.page = 'At least one page must be selected';
      isValid = false;
    }
    if (linkType === 'Custom') {
      if (!linkName.trim()) {
        newErrors.linkName = 'Link Name is required';
        isValid = false;
      }
      if (!templateLink.trim()) {
        newErrors.link = 'Link is required';
        isValid = false;
      }
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleMenuClick = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleAddParameter = (param) => {
    if (!templateLink.includes(param.value)) {
      const updated = `${templateLink}${param.value}`;
      setTemplateLink(updated);
      setLink(updated);
      setSelectedParams(prev => [...prev, param]);
    }
    handleMenuClose();
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const updatedList = [...(data[type === 'agency' ? 'agency_pages' : 'location_pages'] || [])];
    setProcessing(true);

    try {
      if (editData) {
        updatedList[DataIndex] = {
          page: linkType === 'Custom' ? linkName : page[0]?.value,
          link: templateLink,
          templateLink,
          linkType,
        };
      } else {
        if (linkType === 'Pre Defined') {
          page.forEach((pg) => {
            updatedList.push({ page: pg.value, link: '', linkType });
          });
        } else {
          updatedList.push({
            page: linkName,
            link: templateLink,
            templateLink,
            linkType,
          });
        }
      }

      const payload = {
        _id: data._id,
        [type === 'agency' ? 'agency_pages' : 'location_pages']: updatedList,
      };

      const { response } = await Service.snapshot_onboarding.update({ payload });
      if (response) {
        onClose();
        handleChange();
      } else {
        throw new Error('Failed to save changes');
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Failed to save changes',
        confirmButtonColor: '#3085d6',
      });
    } finally {
      setProcessing(false);
    }
  };

  console.log("templateLink", templateLink, "ssodata", ssodata)
  return (
    <MDModal open={open} onClose={onClose}>
      <MDBox>
        <MDTypography component="h1" mb={3} variant="h5">
          {editData ? 'Edit Link' : 'Add New Link'}
        </MDTypography>

        <MDBox component="form" onSubmit={handleSubmit} sx={{ fontSize: '14px' }}>
          <MDBox mb={2}>
            <MDTypography variant="button" display="block" gutterBottom>
              Select Type
            </MDTypography>
            <Select
              options={Types}
              value={Types.find(item => item.value === linkType)}
              onChange={(e) => setLinkType(e.value)}
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor: errors.linkType ? '#d32f2f' : base.borderColor,
                }),
              }}
            />
            {errors.linkType && (
              <MDTypography variant="caption" color="error">
                {errors.linkType}
              </MDTypography>
            )}
          </MDBox>

          {linkType === 'Pre Defined' && (
            <MDBox mb={2}>
              <MDTypography variant="button" display="block" gutterBottom>
                Select Page{editData ? '' : '(s)'}
              </MDTypography>
              <Select
                isMulti={!editData}
                options={availableOptions}
                value={page}
                onChange={(val) => setPage(editData ? [val] : val)}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: errors.page ? '#d32f2f' : base.borderColor,
                  }),
                }}
              />
              {errors.page && (
                <MDTypography variant="caption" color="error">
                  {errors.page}
                </MDTypography>
              )}
            </MDBox>
          )}

          {linkType === 'Custom' && (
            <>
              <MDBox mb={2}>
                <MDTypography variant="button" display="block" gutterBottom>
                  Link Name
                </MDTypography>
                <MDInput
                  fullWidth
                  value={linkName}
                  onChange={(e) => setLinkName(e.target.value)}
                  error={!!errors.linkName}
                />
                {errors.linkName && (
                  <MDTypography variant="caption" color="error">
                    {errors.linkName}
                  </MDTypography>
                )}
              </MDBox>
              <MDBox mb={2}>
                <MDTypography variant="button" display="block" gutterBottom>
                  Link
                </MDTypography>
                <MDInput
                  fullWidth
                  value={templateLink}
                  onChange={(e) => {
                    setTemplateLink(e.target.value);
                    setLink(e.target.value);
                  }}
                  error={!!errors.link}
                />
                {errors.link && (
                  <MDTypography variant="caption" color="error">
                    {errors.link}
                  </MDTypography>
                )}
              </MDBox>
              <MDBox mb={2}>
                <MDTypography variant="button" display="block" gutterBottom>
                  Add Parameters
                </MDTypography>
                <MDButton variant="outlined" color="info" size="small" onClick={handleMenuClick}>
                  Add Parameter
                </MDButton>
                <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleMenuClose}>
                  {parameterOptions.map((param) => (
                    <MenuItem key={param.value} onClick={() => handleAddParameter(param)}>
                      {param.label}
                    </MenuItem>
                  ))}
                </Menu>
              </MDBox>
            </>
          )}
          <MDButton
            variant="gradient"
            color="info"
            type="submit"
            fullWidth
            disabled={processing}
            sx={{ mt: 2 }}
          >
            {editData ? 'Save Changes' : 'Add'}
          </MDButton>
        </MDBox>
      </MDBox>
    </MDModal>
  );
}

const CreateLinkModal = ({ data, handleChange, type, editData, DataIndex }) => {
  const [openAddProduct, setOpenAddProduct] = useState(false);
  return (
    <>
      <MDButton
        variant="contained"
        size="small"
        color="info"
        onClick={() => setOpenAddProduct(true)}
        startIcon={<Icon>{editData ? 'edit' : 'add'}</Icon>}
      >
        {editData ? 'Edit' : 'Add New'}
      </MDButton>

      <AddProduct
        open={openAddProduct}
        onClose={() => setOpenAddProduct(false)}
        data={data}
        handleChange={handleChange}
        type={type}
        editData={editData}
        DataIndex={DataIndex}
      />
    </>
  );
};

export default CreateLinkModal;
